import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  useTheme,
  Divider
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const DeleteConfirmDialog = ({ open, onClose, onConfirm, domain }) => {
  const theme = useTheme()

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 'bold',
          fontSize: '18px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1
        }}
      >
        Are you sure?
        <IconButton onClick={onClose} size='small'>
          <CloseIcon sx={{ color: theme.palette.text.primary }} />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <Typography variant='body2' sx={{ color: theme.palette.text.secondary }}>
          Are you sure you want to delete the domain&nbsp;
          <Box component='span' fontWeight={600}>
            “{domain}”
          </Box>
          ?
        </Typography>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ justifyContent: 'flex-end', px: 3, py: 2 }}>
        <Button
          onClick={onClose}
          variant='outlined'
          sx={{
            borderColor: theme.palette.divider,
            color: theme.palette.primary.main,
            fontWeight: 600,
            mr: 1,
            textTransform: 'none'
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          sx={{
            backgroundColor: theme.palette.error.main,
            color: '#fff',
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: theme.palette.error.dark
            }
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmDialog
